export default __webpack_public_path__ + "static/media/IMG-20240729-WA0013.ddbed294.jpg";